<template>
  <div>
    <div class="row mb-3 pe-4">
      <div class="col-lg-8 col-md-6 col-6 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-2">GrabFood Integration</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-6 d-flex justify-content-end">
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100">
      <div class="c-container">
        <div class="row">
          <div
            class="col-lg-12 col-md-12 col-12 mx-auto pb-5 mt-2"
            v-if="isLoadData"
          >
            <div class="card-body" style="padding: 0rem 0rem">
              <div class="row d-flex">
                <div class="tab-list p-0">
                  <ul id="general-tab" class="nav nav-tabs">
                    <li class="nav-item">
                      <a
                        id="nav_item_1"
                        class="nav-link active"
                        @click="changeTab(1)"
                      >
                        Credential
                      </a>
                    </li>
                    <li class="nav-item">
                      <a id="nav_item_2" class="nav-link" @click="changeTab(2)">
                        Store
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="row card-custom-new mt-3">
                  <!-- Credential Tab -->
                  <div class="col-12" v-if="isCredential">
                    <!-- One Grab developer app serves every merchant: the webhook URLs carry no
                         merchant code and the partner client ID/secret are platform-wide (set by
                         Minty on the Grab portal), so none of them are merchant-specific. -->
                    <!-- Webhook URLs -->
                    <h6 class="fw-bold mb-3">Webhook URLs (for Grab Portal Configuration)</h6>
                    <div class="row mt-2" v-for="(webhook, index) in webhookUrls" :key="index">
                      <div class="col-lg-3 col-12 label-form d-flex align-items-center">
                        {{ webhook.label }}
                      </div>
                      <div class="col-lg-8 col-12 d-flex align-items-center">
                        <code class="me-2 text-break">{{ webhook.url }}</code>
                        <a href="javascript:;" @click="copyToClipboard(webhook.url)" class="text-primary" title="Copy">
                          <i class="fas fa-copy"></i>
                        </a>
                      </div>
                    </div>

                    <h6 class="fw-bold mt-4 mb-3">Partner Credentials (for Grab Portal)</h6>
                    <div class="row">
                      <div class="col-lg-3 col-12 label-form d-flex align-items-center">
                        OAuth scopes
                      </div>
                      <div class="col-lg-6 col-12 d-flex align-items-center">
                        <code class="me-2">{{ form.partner_oauth_scopes }}</code>
                        <a href="javascript:;" @click="copyToClipboard(form.partner_oauth_scopes)" class="text-primary" title="Copy">
                          <i class="fas fa-copy"></i>
                        </a>
                      </div>
                    </div>
                  </div>

                  <!-- Store Tab -->
                  <div class="col-12" v-if="isBranches">
                    <!-- G025: Grab self-serve activation. Grab links the store and reports the
                         result through the integration-status webhook, so the row appears or
                         changes only after the merchant finishes in the Grab tab (Refresh). -->
                    <div class="d-flex flex-wrap align-items-center mb-3" style="gap: 16px">
                      <div class="label-form">Sales Channel</div>
                      <div style="width: 320px; max-width: 100%">
                        <Multiselect
                          :searchable="true"
                          v-model="journeyBranchCode"
                          :options="channelOptions"
                          :canClear="false"
                          placeholder="Select sales channel"
                        />
                      </div>
                      <button
                        type="button"
                        class="btn btn-success btn-background btn-sm mb-0"
                        :disabled="!journeyBranchCode"
                        @click="createJourney(journeyBranchCode)"
                      >
                        Integrate with Grab
                      </button>
                      <a href="javascript:;" class="text-primary text-bold ms-auto" @click="getGrabFoodBranches">
                        <i class="fas fa-sync-alt me-1"></i>Refresh
                      </a>
                    </div>
                    <div class="card-custom">
                      <div class="table-responsive p-0 custom-table">
                        <table class="table align-items-center mb-0">
                          <thead>
                            <tr>
                              <th class="w-2 text-center font-weight-bolder">#</th>
                              <th class="text-center font-weight-bolder">Sales Channel</th>
                              <th class="text-center font-weight-bolder">Orders Link</th>
                              <th class="text-center font-weight-bolder">Menu Set</th>
                              <th class="text-center font-weight-bolder">Status</th>
                              <th class="text-center font-weight-bolder" style="white-space: nowrap; width: 1%;">Grab Response</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(store, index) in branches" :key="index">
                              <td class="text-center text-xss">{{ index + 1 }}</td>
                              <td class="text-center text-xss">{{ store.branch ? store.branch.branch_name : '' }}</td>
                              <td class="text-center text-xss">
                                <a
                                  :href="getOrdersLink(store)"
                                  target="_blank"
                                  class="text-primary"
                                >
                                  {{ getOrdersLink(store) }}
                                </a>
                              </td>
                              <td class="text-center text-xss">{{ menusetNames(store) }}</td>
                              <td class="text-center text-xss">
                                <!-- Grab orders ON/OFF: the merchant's own switch. Saving the Store ID
                                     only sets the store up; Grab's status below never changes it. -->
                                <div class="form-check form-switch d-inline-flex align-items-center ps-0 mb-0">
                                  <input
                                    :id="'grab_orders_' + store.id"
                                    class="form-check-input ms-0"
                                    type="checkbox"
                                    :checked="store.status == 1"
                                    :disabled="togglingStoreId === store.id || (store.status != 1 && !canTurnOn(store))"
                                    @change="setStoreStatus(store, $event)"
                                  />
                                  <label
                                    :for="'grab_orders_' + store.id"
                                    class="form-check-label ms-2 mb-0 fw-bold"
                                    :class="store.status == 1 ? 'text-success' : 'text-danger'"
                                  >
                                    Grab orders {{ store.status == 1 ? 'ON' : 'OFF' }}
                                  </label>
                                </div>
                                <div v-if="store.status != 1 && store.paused_on_grab" class="text-muted">
                                  Paused on Grab
                                </div>
                                <div v-if="store.integration_status" class="mt-1">
                                  <span class="badge badge-sm" :class="integrationBadgeClass(store.integration_status)">
                                    Grab: {{ store.integration_status }}
                                  </span>
                                </div>
                                <div v-if="grabStatusWarning(store)" class="text-warning">
                                  {{ grabStatusWarning(store) }}
                                </div>
                                <div v-if="store.link_status === 'revoked'" class="text-warning">
                                  Turned off by Minty support - please contact Minty support
                                </div>
                                <div v-else-if="store.link_status === 'unrouted'" class="text-warning">
                                  Not active - save the sales channel again
                                </div>
                                <div v-else-if="store.verified === false" class="text-warning">
                                  Not active - save the sales channel again, or contact Minty support
                                </div>
                                <a
                                  v-if="canIntegrate(store)"
                                  href="javascript:;"
                                  class="d-inline-block text-primary text-bold mt-1"
                                  @click="createJourney(storeBranchCode(store))"
                                >
                                  Integrate with Grab
                                </a>
                              </td>
                              <td class="text-center text-xss" style="white-space: nowrap;">
                                <div class="d-flex align-items-center justify-content-between gap-2">
                                  <a
                                    @click="canSync(store) ? syncMenu(store) : null"
                                    :class="canSync(store) ? 'text-primary' : 'text-muted'"
                                    class="d-flex align-items-center text-bold"
                                    title="Sync Menu"
                                    :style="{ cursor: canSync(store) ? 'pointer' : 'not-allowed', opacity: canSync(store) ? 1 : 0.5 }"
                                  >
                                    <i class="fas fa-sync-alt me-1" :class="{ 'fa-spin': syncingStoreId === store.id }"></i>
                                    {{ syncingStoreId === store.id ? 'Syncing...' : 'Sync Menu' }}
                                  </a>
                                  <span
                                    v-if="store.last_menu_sync_status"
                                    :class="store.last_menu_sync_status === 'SUCCESS' ? 'text-green' : 'text-danger'"
                                    class="fw-bold me-1"
                                  >
                                    {{ store.last_menu_sync_status === 'SUCCESS' ? 'Success' : 'Failed' }}
                                  </span>
                                  <div>
                                    <span v-if="store.last_menu_sync_at" class="text-muted">
                                      {{ formatDate(store.last_menu_sync_at) }}
                                    </span>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr v-if="branches.length === 0">
                              <td colspan="6" class="text-center text-xss">No stores found</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <p class="text-xs text-muted mt-2 mb-0">
                      Saving the GrabFood Store ID on the sales channel only sets the store up: sync the menu,
                      then turn Grab orders ON. Turning them OFF also pauses the store on Grab, and Minty keeps it
                      paused until you turn it ON again.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="position-fixed top-1 end-1 z-index-2 message-success">
          <material-snackbar
            v-if="snackbar === 'danger' || snackbar === 'success'"
            title=""
            date=""
            :description="message"
            :icon="{ component: 'campaign', color: 'white' }"
            :color="snackbar"
            :close-handler="closeSnackbar"
          />
        </div>
        <material-loading :active="loaderActive" />
      </div>
    </div>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import Multiselect from "@vueform/multiselect";
import $ from "jquery";
import SettingGrabFoodService from "../../../services/settingGrabFood.service";

export default {
  name: "GrabFoodGeneral",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    Multiselect,
  },
  data() {
    return {
      message: "",
      snackbar: null,
      loaderActive: false,
      isLoadData: true,
      type: 1,
      isCredential: false,
      isBranches: false,
      form: {
        partner_oauth_scopes: "food.partner_api",
      },
      branches: [],
      syncingStoreId: null,
      togglingStoreId: null,
      channels: [],
      journeyBranchCode: null,
    };
  },
  computed: {
    channelOptions() {
      return this.channels.map((channel) => ({ value: channel.branch_code, label: channel.branch_name }));
    },
    apiBaseUrl() {
      const base = process.env.VUE_APP_BASE_URL || "";
      // Remove trailing /api/v1 to get the domain
      return base.replace(/\/api\/v1\/?$/, "");
    },
    webhookUrls() {
      // Shared by every merchant: the backend finds the merchant from Grab's store IDs.
      const base = `${this.apiBaseUrl}/api/v1/grab/webhook`;
      return [
        { label: "Get menu endpoint", url: `${base}/menu` },
        { label: "Submit order endpoint", url: `${base}/submit-order` },
        { label: "Push order state endpoint", url: `${base}/order-state` },
        { label: "OAuth token endpoint", url: `${base}/oauth/token` },
        { label: "Menu Sync Webhook", url: `${base}/menu-sync-state` },
        { label: "Integration status endpoint", url: `${base}/integration-status` },
        { label: "Push Grab menu endpoint", url: `${base}/push-grab-menu` },
      ];
    },
  },
  created() {
    this.changeTab(this.type);
  },
  methods: {
    resetTabs() {
      this.isCredential = false;
      this.isBranches = false;
    },

    changeTab(type) {
      this.resetTabs();
      $("#general-tab .nav-link").removeClass("active");
      $("#nav_item_" + type).addClass("active");
      if (type == 1) {
        this.isCredential = true;
      } else if (type == 2) {
        this.isBranches = true;
        this.getGrabFoodBranches();
        this.getChannels();
      }
    },

    getGrabFoodBranches() {
      this.showLoader();
      SettingGrabFoodService.getGrabFoodBranches().then(
        (response) => {
          const result = response?.data?.result;
          if (result?.isSuccess) {
            this.branches = response.data.data || [];
          } else {
            this.snackbar = "danger";
            this.message = result?.message || "Failed to load stores";
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error?.response?.data?.result?.message || error?.message || "Failed to load stores";
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    getChannels() {
      SettingGrabFoodService.getChannels().then(
        (response) => {
          if (response?.data?.result?.isSuccess) {
            this.channels = response.data.data || [];
          }
        },
        () => {}
      );
    },

    integrationBadgeClass(status) {
      return {
        ACTIVE: "bg-gradient-success",
        SYNCING: "bg-gradient-info",
        FAILED: "bg-gradient-danger",
      }[status] || "bg-secondary";
    },

    // Offer the journey only where the link is not live, or Grab reports the integration
    // is not running (FAILED, INACTIVE, SYNCING). A live store with no Grab status (linked
    // by its Store ID) must not be re-linked by a click.
    canIntegrate(store) {
      return store.verified === false
        || ["FAILED", "INACTIVE", "SYNCING"].includes(store.integration_status);
    },

    // Grab orders can be turned ON only for a live link (a revoked or pending one cannot).
    canTurnOn(store) {
      return store.link_status ? store.link_status === "verified" : store.verified !== false;
    },

    // When Minty's switch and Grab's state disagree, say what it means for orders.
    grabStatusWarning(store) {
      if (store.status == 1 && ["FAILED", "INACTIVE"].includes(store.integration_status)) {
        return "Grab is not sending orders. Fix any menu errors and click Sync Menu, or check the Grab Merchant app.";
      }
      if (store.status != 1 && store.integration_status === "ACTIVE" && !store.paused_on_grab && store.verified !== false) {
        return "Grab may still take orders that Minty will refuse. Turn Grab orders ON, or turn them OFF again to pause the store on Grab.";
      }
      return "";
    },

    setStoreStatus(store, event) {
      const status = event.target.checked ? 1 : 0;
      // The switch shows the saved state until the backend (and Grab) answer.
      event.target.checked = store.status == 1;

      if (status === 0 && !confirm("Turn Grab orders OFF for " + (store.branch ? store.branch.branch_name : "this store") + "? Minty will refuse its Grab orders and pause the store on Grab.")) {
        return;
      }

      this.togglingStoreId = store.id;
      this.showLoader();
      SettingGrabFoodService.setStoreStatus(store.branch_id, status).then(
        (response) => {
          const result = response?.data?.result;
          const data = response?.data?.data || {};
          if (result?.isSuccess) {
            store.status = data.status;
            store.paused_on_grab = data.paused_on_grab;
            this.snackbar = data.warning ? "danger" : "success";
            this.message = data.warning || ("Grab orders are " + (data.status == 1 ? "ON" : "OFF") + ".");
          } else {
            this.snackbar = "danger";
            this.message = result?.message || "Failed to change Grab orders";
          }
          this.togglingStoreId = null;
          this.hideLoader();
          this.setTimeOutNotification(data.warning ? 8000 : 3000);
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error?.response?.data?.result?.message || error?.message || "Failed to change Grab orders";
          this.togglingStoreId = null;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    storeBranchCode(store) {
      return store.branch ? store.branch.branch_code : store.branch_code;
    },

    // Opens Grab's activation page in a new tab. The tab is opened inside the click
    // handler, before the request, so the browser does not block it as a popup.
    createJourney(branchCode) {
      const grabTab = window.open("", "_blank");
      this.showLoader();
      SettingGrabFoodService.createJourney(branchCode).then(
        (response) => {
          const result = response?.data?.result;
          const url = response?.data?.data?.activation_url;
          if (result?.isSuccess && url) {
            if (grabTab) {
              grabTab.location.href = url;
            } else {
              window.location.href = url;
            }
            this.snackbar = "success";
            this.message = "Complete the integration in the Grab tab, then click Refresh.";
          } else {
            if (grabTab) grabTab.close();
            this.snackbar = "danger";
            this.message = result?.message || "Failed to start Grab integration";
          }
          this.hideLoader();
          this.setTimeOutNotification();
        },
        (error) => {
          if (grabTab) grabTab.close();
          this.snackbar = "danger";
          this.message = error?.response?.data?.result?.message || error?.message || "Failed to start Grab integration";
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    // Grab fetches the menu through the webhooks, which refuse a link that is not live,
    // so syncing it could only fail. Grab orders ON or OFF does not matter: the menu is
    // set up before turning orders on.
    canSync(store) {
      return store.verified !== false;
    },

    getOrdersLink(store) {
      const merchantId = localStorage.getItem("MERCHANT_ID") || "";
      const branchCode = store.branch_code || (store.branch ? store.branch.branch_code : "");
      return `${window.location.origin}/branch/orders/${merchantId}/${branchCode}`;
    },

    // Each menu set the channel syncs becomes its own Grab menu section, so all
    // of them are listed. Falls back to the single menuset for a response from a
    // backend that predates menuset_names.
    menusetNames(store) {
      if (store.menuset_names && store.menuset_names.length) {
        return store.menuset_names.join(", ");
      }
      return store.branch && store.branch.menuset ? store.branch.menuset.name : "";
    },

    formatDate(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = date.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    },

    syncMenu(store) {
      this.syncingStoreId = store.id;
      this.showLoader();
      SettingGrabFoodService.syncMenu(store.grab_store_id).then(
        (response) => {
          this.syncingStoreId = null;
          const result = response?.data?.result;
          if (result?.isSuccess) {
            this.snackbar = "success";
            this.message = response?.data?.data?.message || "Menu sync triggered";
            this.setTimeOutNotification();

            // Optimistic UI update: mark this store as SUCCESS immediately.
            // The real final status will arrive later via Grab's menu-sync-state webhook,
            // at which point the next reload will reflect the actual result.
            const idx = this.branches.findIndex((b) => b.id === store.id);
            if (idx !== -1) {
              this.branches[idx].last_menu_sync_status = "SUCCESS";
              this.branches[idx].last_menu_sync_at = new Date().toISOString();
              this.branches[idx].last_menu_sync_error = null;
            }
          } else {
            this.snackbar = "danger";
            this.message = result?.message || "Sync failed";
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.syncingStoreId = null;
          this.snackbar = "danger";
          this.message = error?.response?.data?.result?.message || error?.message || "Sync failed";
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.snackbar = "success";
        this.message = "Copied to clipboard";
        this.setTimeOutNotification();
      });
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification(delay = 3000) {
      setTimeout(() => {
        this.snackbar = null;
      }, delay);
    },

    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },
  },
};
</script>

<style scoped>
.c-container {
  width: 100%;
  max-width: 100%;
  padding-left: 25px;
  padding-right: 25px;
}

.tab-list {
  overflow-x: auto;
  padding-bottom: 5px !important;
}

.tab-list::-webkit-scrollbar {
  height: 7px;
}

.tab-list::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.tab-list::-webkit-scrollbar-thumb {
  background: #888;
}

.tab-list::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.tab-list #general-tab {
  flex-wrap: unset !important;
}

.tab-list #general-tab li.nav-item {
  min-width: fit-content;
}

.multiselect {
  max-width: 500px !important;
  margin-left: 0;
}
</style>
